import styled from "styled-components";

export const Div = styled.div`
	.des-container {
		margin-top: 10px;
		white-space: pre-line;
	}
	.service-description {
		overflow: hidden;
		position: relative;
		margin-bottom: 10px;
		font-size: 0.9375rem;
	}
	.description {
		overflow: hidden;
		position: relative;
		font-size: 0.9375rem;
	}
	.toggle-icon {
		display: flex;
	}
	.toggle-icon svg {
		margin: auto 0;
		margin-left: 5px;
	}
	.firm-url{
		margin: 5px 0px
	}
	.card-title-sub {
		display: flex;
		/* padding: 0 10px 20px 0; */
		h2 {
			font-size: 1.1875rem;
			font-weight: 700;
			flex: 1;
		}
	}
`;

export const DesContent = styled.div`
	color: #637381;
	white-space: pre-line;
`;

export const ToggleButton = styled.button``;

export const PHeader = styled.p`
	font-weight: 700;
	font-size: 1rem;
	line-height: 22px;
	color: #000000;
`;
